import '@fortawesome/fontawesome-free/css/all.min.css';

import Header from './Header';
import Sidebar from './Sidebar';

function index({ children, title, patientguid, diseaseName }) {
  return (
    <main className="flex-colo bg-dry">
      <div className="grid w-full grid-cols-12">
        <aside className="col-span-2 hidden xl:block">
          <Sidebar patientguid={patientguid} diseaseName={diseaseName} />
        </aside>

        <div className="relative col-span-10 overflow-y-scroll xl:h-screen">
          <Header title={title} />

          {/* content */}
          <div className="p-10 px-16">{children}</div>
        </div>
      </div>
    </main>
  );
}

export default index;
